import { matchRoutes } from 'react-router-config';
import history from './history';
import type { RouteConfig } from './types';

export default <T extends RouteConfig>(routes: T[]): T | undefined =>
    matchRoutes(routes, history.location.pathname).find((item) => item.match.isExact)?.route;
